// src/helpers/rutaCamiones.js

import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

/* =========================================================
   API
========================================================= */

const getToken = () => localStorage.getItem("token") || "";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers.token = getToken();

  return config;
});

/* =========================================================
   NORMALIZAR ERROR
========================================================= */

const normError = (error, fallbackMsg) => ({
  ok: false,

  error:
    error?.response?.data?.error ||
    error?.response?.data?.err?.message ||
    error?.response?.data ||
    error?.message ||
    fallbackMsg ||
    "Error de red",
});

/* =========================================================
   GET /camiones

   Mantiene compatibilidad con todo el sistema actual.

   Opciones:
   {
     incluirInactivos: true,
     tipoUnidad: "CAMION",
     titular: "DANLU",
     q: "SCANIA"
   }
========================================================= */

export const getCamiones = async (opts = {}) => {
  try {
    const params = {};

    if (opts.incluirInactivos === true) {
      params.incluirInactivos = 1;
    }

    if (opts.tipoUnidad) {
      params.tipoUnidad = opts.tipoUnidad;
    }

    if (opts.titular) {
      params.titular = opts.titular;
    }

    if (opts.q) {
      params.q = opts.q;
    }

    const resp = await api.get("/camiones", {
      params,
    });

    return resp.data;
  } catch (error) {
    return normError(
      error,
      "Error al obtener vehículos"
    );
  }
};

/* =========================================================
   GET /camiones/:id
========================================================= */

export const getCamionById = async (id) => {
  if (!id) {
    return {
      ok: false,
      error: "Debe indicar el vehículo.",
    };
  }

  try {
    const resp = await api.get(
      `/camiones/${id}`
    );

    return resp.data;
  } catch (error) {
    return normError(
      error,
      "Error al obtener vehículo"
    );
  }
};

/* =========================================================
   POST /camiones
   CREAR VEHÍCULO
========================================================= */

export const postCamion = async (camionData) => {
  try {
    const resp = await api.post(
      "/camiones",
      camionData
    );

    return resp.data;
  } catch (error) {
    return normError(
      error,
      "Error al crear vehículo"
    );
  }
};

/* =========================================================
   PUT /camiones/:id
   ACTUALIZAR VEHÍCULO
========================================================= */

export const putCamion = async (
  id,
  camionData
) => {
  if (!id) {
    return {
      ok: false,
      error: "Debe indicar el vehículo.",
    };
  }

  try {
    const resp = await api.put(
      `/camiones/${id}`,
      camionData
    );

    return resp.data;
  } catch (error) {
    return normError(
      error,
      "Error al actualizar vehículo"
    );
  }
};

/* =========================================================
   DELETE /camiones/:id
   BAJA LÓGICA

   motivoBaja es opcional.
========================================================= */

export const deleteCamion = async (
  id,
  motivoBaja = ""
) => {
  if (!id) {
    return {
      ok: false,
      error: "Debe indicar el vehículo.",
    };
  }

  try {
    const resp = await api.delete(
      `/camiones/${id}`,
      {
        data: {
          motivoBaja,
        },
      }
    );

    return resp.data;
  } catch (error) {
    return normError(
      error,
      "Error al desactivar vehículo"
    );
  }
};